export interface ISiteScript {
  bucket_excluded: number | null;
  bucket_excluded_daily_history: string[];
  embed_code: string;
  is_empty: boolean;
  key: string;
}

class SiteScript {
  public readonly bucketExcluded: number | null;
  public readonly bucketExcludedDailyHistory: string[];
  public readonly embedCode: string;
  public readonly isEmpty: boolean;
  public readonly key: string;

  constructor({
    bucketExcluded,
    bucketExcludedDailyHistory,
    embedCode,
    isEmpty,
    key,
  }: {
    bucketExcluded: number | null;
    bucketExcludedDailyHistory: string[];
    embedCode: string;
    isEmpty: boolean;
    key: string;
  }) {
    this.bucketExcluded = bucketExcluded;
    this.bucketExcludedDailyHistory = bucketExcludedDailyHistory;
    this.embedCode = embedCode;
    this.isEmpty = isEmpty;
    this.key = key;
  }

  public toJSON = () => ({
    bucketExcluded: this.bucketExcluded,
    bucketExcludedDailyHistory: this.bucketExcludedDailyHistory,
    embedCode: this.embedCode,
    isEmpty: this.isEmpty,
    key: this.key,
  });

  public static fromJSON = (json: ISiteScript): SiteScript => {
    const {
      bucket_excluded: bucketExcluded,
      bucket_excluded_daily_history: bucketExcludedDailyHistory,
      embed_code: embedCode,
      is_empty: isEmpty,
      key,
    } = Object.assign({}, json);

    if (typeof bucketExcluded !== 'number' && bucketExcluded !== null)
      throw new Error('.bucketExcluded must be a string');
    if (typeof embedCode !== 'string') throw new Error('.embedCode must be a string');
    if (typeof isEmpty !== 'boolean') throw new Error('.isEmpty must be a boolean');
    if (typeof key !== 'string') throw new Error('.key must be a string');

    const _bucketExcludedDailyHistory = bucketExcludedDailyHistory.map((item: string) => {
      return item;
    });

    return new SiteScript({
      bucketExcluded,
      bucketExcludedDailyHistory: _bucketExcludedDailyHistory,
      embedCode,
      isEmpty,
      key,
    });
  };
}

export default SiteScript;
